import classNames from "classnames";

function Divider({ vertical = false }) {
  const clazzes = classNames("divider", { vertical: vertical });

  return <div className={clazzes} />;
}

export default Divider;
